import { AllPlatform } from "../../../components/Contents/seecharleepage/AllPlatform"
import { Footer } from "../../../components/footers/Footer"
import { FooterBanner } from "../../../components/footers/FooterBanner"
import { HomeHeader } from "../../../components/headers/HomeHeader"
import { SeeCharleeHero } from "../../../components/heros/SeeCharleeHero"
import { PageMain } from "../../../components/seo/PageMain"
import { PageSeoHelmet } from "../../../components/seo/PageSeoHelmet"
import { STATIC_PAGE_SEO_META } from "../../../components/seo/staticPageSeoMeta"

import SplitType from 'split-type'
import gsap, {} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import TextPlugin from "gsap/TextPlugin";
import { useGSAP } from '@gsap/react';
import { useRef } from "react"

gsap.registerPlugin(useGSAP, ScrollTrigger, TextPlugin);
export const SeeCharlee = () => {
  const seeCharleeRef = useRef();
  useGSAP(() => {
    const seeCharleeLogo = gsap.utils.toArray('.seecharlee-logo');
    const seeCharleeLogoTxt = gsap.utils.toArray('.askcharlee-logoText');
    const seeCharleeHead = gsap.utils.toArray('.askCharlee-head');
    const seeCharleeText = new SplitType('.askCharlee-text-inner', {
      types: 'lines',
      tagName: 'span',
    });
    const seeCharleeBook = gsap.utils.toArray('.askCharlee-book');
    const seeCharleeReviewTxt = new SplitType('.askCharlee-reveiwTxt-inner', {
      types: 'lines',
      tagName: 'span',
    });
    const seeCharleeReviewer = gsap.utils.toArray('.askCharlee-reviewer');
    const seeCharleeDashboardImg = gsap.utils.toArray('.seeCharlee-bashboardImg');
    
    const seeCharleeTimeline = gsap.timeline();
    seeCharleeTimeline.fromTo(seeCharleeLogo[0], {opacity: 0, clipPath: 'inset(100%)'}, {opacity: 1, clipPath: 'inset(0%)', duration: 0.5});
    seeCharleeTimeline.fromTo(
      seeCharleeLogoTxt[0],
      { opacity: 0, y: 12 },
      { opacity: 1, y: 0, duration: 0.7, ease: 'power4.out' },
      '+=0'
    );
    seeCharleeTimeline.fromTo(
      seeCharleeHead[0],
      { y: '50%', opacity: 0 },
      { y: '0', opacity: 1, duration: 0.9, ease: 'power4.out' },
      "+=0"
    )
    seeCharleeTimeline.fromTo(
      seeCharleeText.lines,
      {
        y: '-50%',
        opacity: 0
      },
      {
        y: '0',
        opacity: 1,
        stagger: 0.1,
        duration: 0.5,
        ease: 'power4.out',
      },
      "+=0"
    )
    seeCharleeTimeline.fromTo(
      seeCharleeBook[0],
      {
        opacity: 0,
        clipPath: 'inset(0% 0% 100% 0%)',
      },
      {
        opacity: 1,
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 0.5
      },
      '+=0'
    )
    seeCharleeTimeline.fromTo(
      seeCharleeReviewTxt.lines,
      {
        y: '-50%',
        opacity: 0,
      },
      {
        y: '0',
        opacity: 1,
        stagger: 0.05,
        duration: 0.5,
        ease: 'power4.out',
      },
      "+=0"
    )
    seeCharleeTimeline.fromTo(
      seeCharleeReviewer[0],
      {
        opacity: 0,
        clipPath: 'inset(100% 0% 0% 0%)'
      },
      {
        opacity: 1,
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 0.5 
      },
      "+=0"
    )

    gsap.fromTo(seeCharleeDashboardImg[0], {opacity: 0, x: '-100%'}, {opacity: 1, x: '0', duration: 2})
        // gsap.utils.toArray('.seecharlee-logoText')
  },  {
    scope: seeCharleeRef
  })
  return (
    <>
      <PageSeoHelmet {...STATIC_PAGE_SEO_META.products.seecharlee} />
      <div className="w-full overflow-hidden bg-[#F9F9F9]">
        <HomeHeader headerColor={'#F9F9F9'} textColor={'#021744'} />
        <PageMain ref={seeCharleeRef} className="seeCharlee-page">
          <SeeCharleeHero />
          <AllPlatform />
        </PageMain>
        <FooterBanner />
        <Footer />
      </div>
    </>
  );
}